'use client';

import { Tweet } from 'react-tweet';
import { resolveTwitterId } from '../providers';

interface TwitterEmbedProps {
  src?: string;
  url?: string;
  id?: string;
}

/**
 * X/Twitter via react-tweet. Unlike widgets.js this fetches the tweet through
 * the syndication API (no global third-party script), styles with the design
 * tokens, and degrades gracefully for deleted tweets.
 */
export function TwitterEmbed({ src, url, id }: TwitterEmbedProps) {
  const statusId = resolveTwitterId(id ?? src ?? url);
  if (!statusId) return null;

  return (
    <div className='my-lg flex justify-center [&_.react-tweet-theme]:my-0'>
      <Tweet id={statusId} />
    </div>
  );
}
